import { trimEdges } from './upload-path';

const TEXT_TYPES = new Set(['', 'text', 'search', 'email', 'tel', 'url', 'password']);

/** 离开输入框时去掉两侧空格，以及不换行空格、全角空格、零宽字符这类空白。 */
export function installEdgeTrim(target: Document = document): void {
  target.addEventListener(
    'focusout',
    (event) => {
      const node = event.target;
      if (!(node instanceof HTMLInputElement || node instanceof HTMLTextAreaElement)) return;
      if (node.readOnly || node.disabled) return;
      if (node instanceof HTMLInputElement && !TEXT_TYPES.has(node.type)) return;
      const next = trimEdges(node.value);
      if (next === node.value) return;
      node.value = next;
      node.dispatchEvent(new Event('input', { bubbles: true }));
    },
    true,
  );
}
